import React, { useContext, useEffect } from 'react';
import { Form, Input, Button, Card, Row, Col, Space, message } from 'antd';
import { SaveOutlined, LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useFetch } from '../../hooks';
import { LayoutContext } from '../../contexts';
import { URLS } from '../../constants';

const { TextArea } = Input;

function NotificationCreate() {
  const navigate = useNavigate();
  const { setHeaderComponent } = useContext(LayoutContext);
  const [form] = Form.useForm();
  const { doFetch: createNotificationFetch } = useFetch();

  useEffect(() => {
    setHeaderComponent('Create New Notification');

    return () => {
      setHeaderComponent(null);
    };
  }, [setHeaderComponent]);

  const handleSubmit = async (values) => {
    const formData = {
      title: values.title,
      description: values.description || '',
    };

    createNotificationFetch({
      url: URLS.createNotification(),
      method: 'POST',
      params: formData,
      onSuccess: () => {
        message.success('Notification created successfully!');
        navigate('/notifications');
      },
      onError: (error) => {
        message.error('Failed to create notification. Please try again.');
        console.error('Error creating notification:', error);
      },
      showSuccessNotification: true,
      successMessage: 'Notification created successfully',
    });
  };

  const handleCancel = () => {
    navigate('/notifications');
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16} xl={12}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="title"
              label="Notification Title"
              rules={[
                { required: true, message: 'Please enter a notification title' },
                { max: 255, message: 'Title must be less than 255 characters' },
              ]}
            >
              <Input
                placeholder="Enter notification title"
              />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
            >
              <TextArea
                rows={6}
                placeholder="Enter notification description (optional)"
                showCount
                maxLength={1000}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" icon={<SaveOutlined />} size="large">
                  Create Notification
                </Button>
                <Button icon={<LeftOutlined />} onClick={handleCancel} size="large">
                  Cancel
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}

export default NotificationCreate;

